"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = parseQuery;

var _recursiveUnbracket = _interopRequireDefault(require("../recursiveUnbracket"));

// utils
function parseQuery(query) {
  if (query.length === 0) {
    return {};
  }

  if (query.startsWith("?")) {
    query = query.substr(1);
  }

  return query.split("&").reduce((peerAcc, peer) => {
    const [rawName, value] = peer.split("=");

    if ("" !== rawName && undefined !== value) {
      let parentRef;
      let ref = peerAcc;
      let parentKeyName;
      (0, _recursiveUnbracket.default)(rawName).forEach((keyName, index, nameList) => {
        let localKeyName = decodeURIComponent(keyName);

        if (ref === null) {
          parentRef[parentKeyName] = ref = localKeyName === "" ? [] : {};
        }

        if ("object" === typeof ref) {
          if (!Object.prototype.hasOwnProperty.call(ref, localKeyName)) {
            if (localKeyName === "") {
              localKeyName = Object.keys(ref).length;
              ref[localKeyName] = null;
            } else {
              ref[localKeyName] = null;
            }
          }

          if (index === nameList.length - 1) {
            ref[localKeyName] = decodeURIComponent(value);
          }
        }

        parentRef = ref;
        parentKeyName = localKeyName;
        ref = ref[keyName];
      });
    }

    return peerAcc;
  }, {});
}